<template>
    <div style="width: 100%; background: #fff; height: 87.8vh" class="pubmed">
        <div class="pubmed-width">
            <pubmed-media media="video" :paper-no="paper_no" :status="2"/>
        </div>
    </div>
</template>

<script>

    import {get_args} from "../utils/request";
    import PubmedMedia from "./PubmedMedia";
    export default {
        name: "PubmedVideo",
        components: {
            PubmedMedia
        },
        data(){
            let {p} = get_args();
            return {
                loading: true,
                paper_no: Number(p),
            }
        },
        created(){
        },
        methods: {

        }
    }
</script>

<style scoped>
    .pubmed-width{
        width: 1200px;
        margin: 10px auto;
        word-wrap: break-word!important; /* 旧版浏览器支持 */
        overflow-wrap: break-word!important; /* 标准属性 */
        word-break: break-all;
    }
    /*{*/
    /*  xs: '480px',*/
    /*  sm: '576px',*/
    /*  md: '768px',*/
    /*  lg: '992px',*/
    /*  xl: '1200px',*/
    /*  xxl: '1600px',*/
    /*}*/
    /* 当视口宽度小于 600px 时 */
    @media (max-width: 480px) {
        .pubmed-width {
            width: 100%;
            border: 1px solid red;
            overflow-wrap: break-word!important; /* 标准属性 */
            word-break: break-all;
        }
    }
</style>
